/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as EmailBestaetigenRouteImport } from './routes/email-bestaetigen'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PasswortNeuRouteImport } from './routes/passwort-neu'
import { Route as PasswortVergessenRouteImport } from './routes/passwort-vergessen'
import { Route as RegistrierenRouteImport } from './routes/registrieren'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as StartRouteImport } from './routes/start'
import { Route as UiRouteImport } from './routes/ui'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppKontoRouteImport } from './routes/_app/konto'
import { Route as EinladungTokenRouteImport } from './routes/einladung.$token'
import { Route as ProfilTokenRouteImport } from './routes/profil.$token'
import { Route as AppIchIndexRouteImport } from './routes/_app/ich/index'
import { Route as AppIchAbrechnungenRouteImport } from './routes/_app/ich/abrechnungen'
import { Route as AppIchTermineRouteImport } from './routes/_app/ich/termine'
import { Route as AppKaderIndexRouteImport } from './routes/_app/kader/index'
import { Route as AppKaderPersonIdRouteImport } from './routes/_app/kader/$personId'
import { Route as AppKaderMedizinRouteImport } from './routes/_app/kader/medizin'
import { Route as AppKaderStatistikRouteImport } from './routes/_app/kader/statistik'
import { Route as AppKaderVergleichRouteImport } from './routes/_app/kader/vergleich'
import { Route as AppLigaIndexRouteImport } from './routes/_app/liga/index'
import { Route as AppSpieleIndexRouteImport } from './routes/_app/spiele/index'
import { Route as AppSpieleMatchIdRouteImport } from './routes/_app/spiele/$matchId'
import { Route as AppSpieleVideoRouteImport } from './routes/_app/spiele/video'
import { Route as AppTaktikIndexRouteImport } from './routes/_app/taktik/index'
import { Route as AppTaktikBoardIdRouteImport } from './routes/_app/taktik/$boardId'
import { Route as AppTrainingIndexRouteImport } from './routes/_app/training/index'
import { Route as AppTrainingSessionIdRouteImport } from './routes/_app/training/$sessionId'
import { Route as AppTrainingAnwesenheitRouteImport } from './routes/_app/training/anwesenheit'
import { Route as AppTrainingKalenderRouteImport } from './routes/_app/training/kalender'
import { Route as AppVereinIndexRouteImport } from './routes/_app/verein/index'
import { Route as AppKaderTalenteIndexRouteImport } from './routes/_app/kader/talente/index'
import { Route as AppKaderTalenteProspectIdRouteImport } from './routes/_app/kader/talente/$prospectId'
import { Route as AppLigaVereineIndexRouteImport } from './routes/_app/liga/vereine/index'
import { Route as AppLigaVereineClubIdRouteImport } from './routes/_app/liga/vereine/$clubId'
import { Route as AppVereinBetriebIndexRouteImport } from './routes/_app/verein/betrieb/index'
import { Route as AppVereinBetriebBelegungRouteImport } from './routes/_app/verein/betrieb/belegung'
import { Route as AppVereinBetriebDiensteRouteImport } from './routes/_app/verein/betrieb/dienste'
import { Route as AppVereinBetriebInventarRouteImport } from './routes/_app/verein/betrieb/inventar'
import { Route as AppVereinBudgetsIndexRouteImport } from './routes/_app/verein/budgets/index'
import { Route as AppVereinDatenquellenIndexRouteImport } from './routes/_app/verein/datenquellen/index'
import { Route as AppVereinDatenquellenZuordnungenRouteImport } from './routes/_app/verein/datenquellen/zuordnungen'
import { Route as AppVereinDatenschutzIndexRouteImport } from './routes/_app/verein/datenschutz/index'
import { Route as AppVereinEinstellungenIndexRouteImport } from './routes/_app/verein/einstellungen/index'
import { Route as AppVereinFahrtkostenIndexRouteImport } from './routes/_app/verein/fahrtkosten/index'
import { Route as AppVereinFinanzenIndexRouteImport } from './routes/_app/verein/finanzen/index'
import { Route as AppVereinFinanzenKassenbuchRouteImport } from './routes/_app/verein/finanzen/kassenbuch'
import { Route as AppVereinFinanzenKontenRouteImport } from './routes/_app/verein/finanzen/konten'
import { Route as AppVereinMitgliederIndexRouteImport } from './routes/_app/verein/mitglieder/index'
import { Route as AppVereinPraemienIndexRouteImport } from './routes/_app/verein/praemien/index'
import { Route as AppVereinPraemienAbschlussRouteImport } from './routes/_app/verein/praemien/abschluss'
import { Route as AppVereinPraemienArtenRouteImport } from './routes/_app/verein/praemien/arten'
import { Route as AppVereinSponsorenIndexRouteImport } from './routes/_app/verein/sponsoren/index'
import { Route as AppVereinVorstandIndexRouteImport } from './routes/_app/verein/vorstand/index'
import { Route as AppVereinPraemienVertraegeIndexRouteImport } from './routes/_app/verein/praemien/vertraege/index'
import { Route as AppVereinPraemienVertraegeContractIdRouteImport } from './routes/_app/verein/praemien/vertraege/$contractId'
import { Route as AppVereinPraemienVertraegeNeuRouteImport } from './routes/_app/verein/praemien/vertraege/neu'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DatenschutzRoute = DatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailBestaetigenRoute = EmailBestaetigenRouteImport.update({
  id: '/email-bestaetigen',
  path: '/email-bestaetigen',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswortNeuRoute = PasswortNeuRouteImport.update({
  id: '/passwort-neu',
  path: '/passwort-neu',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswortVergessenRoute = PasswortVergessenRouteImport.update({
  id: '/passwort-vergessen',
  path: '/passwort-vergessen',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrierenRoute = RegistrierenRouteImport.update({
  id: '/registrieren',
  path: '/registrieren',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const UiRoute = UiRouteImport.update({
  id: '/ui',
  path: '/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppKontoRoute = AppKontoRouteImport.update({
  id: '/konto',
  path: '/konto',
  getParentRoute: () => AppRoute,
} as any)
const EinladungTokenRoute = EinladungTokenRouteImport.update({
  id: '/einladung/$token',
  path: '/einladung/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilTokenRoute = ProfilTokenRouteImport.update({
  id: '/profil/$token',
  path: '/profil/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIchIndexRoute = AppIchIndexRouteImport.update({
  id: '/ich/',
  path: '/ich/',
  getParentRoute: () => AppRoute,
} as any)
const AppIchAbrechnungenRoute = AppIchAbrechnungenRouteImport.update({
  id: '/ich/abrechnungen',
  path: '/ich/abrechnungen',
  getParentRoute: () => AppRoute,
} as any)
const AppIchTermineRoute = AppIchTermineRouteImport.update({
  id: '/ich/termine',
  path: '/ich/termine',
  getParentRoute: () => AppRoute,
} as any)
const AppKaderIndexRoute = AppKaderIndexRouteImport.update({
  id: '/kader/',
  path: '/kader/',
  getParentRoute: () => AppRoute,
} as any)
const AppKaderPersonIdRoute = AppKaderPersonIdRouteImport.update({
  id: '/kader/$personId',
  path: '/kader/$personId',
  getParentRoute: () => AppRoute,
} as any)
const AppKaderMedizinRoute = AppKaderMedizinRouteImport.update({
  id: '/kader/medizin',
  path: '/kader/medizin',
  getParentRoute: () => AppRoute,
} as any)
const AppKaderStatistikRoute = AppKaderStatistikRouteImport.update({
  id: '/kader/statistik',
  path: '/kader/statistik',
  getParentRoute: () => AppRoute,
} as any)
const AppKaderVergleichRoute = AppKaderVergleichRouteImport.update({
  id: '/kader/vergleich',
  path: '/kader/vergleich',
  getParentRoute: () => AppRoute,
} as any)
const AppLigaIndexRoute = AppLigaIndexRouteImport.update({
  id: '/liga/',
  path: '/liga/',
  getParentRoute: () => AppRoute,
} as any)
const AppSpieleIndexRoute = AppSpieleIndexRouteImport.update({
  id: '/spiele/',
  path: '/spiele/',
  getParentRoute: () => AppRoute,
} as any)
const AppSpieleMatchIdRoute = AppSpieleMatchIdRouteImport.update({
  id: '/spiele/$matchId',
  path: '/spiele/$matchId',
  getParentRoute: () => AppRoute,
} as any)
const AppSpieleVideoRoute = AppSpieleVideoRouteImport.update({
  id: '/spiele/video',
  path: '/spiele/video',
  getParentRoute: () => AppRoute,
} as any)
const AppTaktikIndexRoute = AppTaktikIndexRouteImport.update({
  id: '/taktik/',
  path: '/taktik/',
  getParentRoute: () => AppRoute,
} as any)
const AppTaktikBoardIdRoute = AppTaktikBoardIdRouteImport.update({
  id: '/taktik/$boardId',
  path: '/taktik/$boardId',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainingIndexRoute = AppTrainingIndexRouteImport.update({
  id: '/training/',
  path: '/training/',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainingSessionIdRoute = AppTrainingSessionIdRouteImport.update({
  id: '/training/$sessionId',
  path: '/training/$sessionId',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainingAnwesenheitRoute = AppTrainingAnwesenheitRouteImport.update({
  id: '/training/anwesenheit',
  path: '/training/anwesenheit',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainingKalenderRoute = AppTrainingKalenderRouteImport.update({
  id: '/training/kalender',
  path: '/training/kalender',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinIndexRoute = AppVereinIndexRouteImport.update({
  id: '/verein/',
  path: '/verein/',
  getParentRoute: () => AppRoute,
} as any)
const AppKaderTalenteIndexRoute = AppKaderTalenteIndexRouteImport.update({
  id: '/kader/talente/',
  path: '/kader/talente/',
  getParentRoute: () => AppRoute,
} as any)
const AppKaderTalenteProspectIdRoute =
  AppKaderTalenteProspectIdRouteImport.update({
    id: '/kader/talente/$prospectId',
    path: '/kader/talente/$prospectId',
    getParentRoute: () => AppRoute,
  } as any)
const AppLigaVereineIndexRoute = AppLigaVereineIndexRouteImport.update({
  id: '/liga/vereine/',
  path: '/liga/vereine/',
  getParentRoute: () => AppRoute,
} as any)
const AppLigaVereineClubIdRoute = AppLigaVereineClubIdRouteImport.update({
  id: '/liga/vereine/$clubId',
  path: '/liga/vereine/$clubId',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinBetriebIndexRoute = AppVereinBetriebIndexRouteImport.update({
  id: '/verein/betrieb/',
  path: '/verein/betrieb/',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinBetriebBelegungRoute =
  AppVereinBetriebBelegungRouteImport.update({
    id: '/verein/betrieb/belegung',
    path: '/verein/betrieb/belegung',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinBetriebDiensteRoute = AppVereinBetriebDiensteRouteImport.update({
  id: '/verein/betrieb/dienste',
  path: '/verein/betrieb/dienste',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinBetriebInventarRoute =
  AppVereinBetriebInventarRouteImport.update({
    id: '/verein/betrieb/inventar',
    path: '/verein/betrieb/inventar',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinBudgetsIndexRoute = AppVereinBudgetsIndexRouteImport.update({
  id: '/verein/budgets/',
  path: '/verein/budgets/',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinDatenquellenIndexRoute =
  AppVereinDatenquellenIndexRouteImport.update({
    id: '/verein/datenquellen/',
    path: '/verein/datenquellen/',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinDatenquellenZuordnungenRoute =
  AppVereinDatenquellenZuordnungenRouteImport.update({
    id: '/verein/datenquellen/zuordnungen',
    path: '/verein/datenquellen/zuordnungen',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinDatenschutzIndexRoute =
  AppVereinDatenschutzIndexRouteImport.update({
    id: '/verein/datenschutz/',
    path: '/verein/datenschutz/',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinEinstellungenIndexRoute =
  AppVereinEinstellungenIndexRouteImport.update({
    id: '/verein/einstellungen/',
    path: '/verein/einstellungen/',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinFahrtkostenIndexRoute =
  AppVereinFahrtkostenIndexRouteImport.update({
    id: '/verein/fahrtkosten/',
    path: '/verein/fahrtkosten/',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinFinanzenIndexRoute = AppVereinFinanzenIndexRouteImport.update({
  id: '/verein/finanzen/',
  path: '/verein/finanzen/',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinFinanzenKassenbuchRoute =
  AppVereinFinanzenKassenbuchRouteImport.update({
    id: '/verein/finanzen/kassenbuch',
    path: '/verein/finanzen/kassenbuch',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinFinanzenKontenRoute = AppVereinFinanzenKontenRouteImport.update({
  id: '/verein/finanzen/konten',
  path: '/verein/finanzen/konten',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinMitgliederIndexRoute =
  AppVereinMitgliederIndexRouteImport.update({
    id: '/verein/mitglieder/',
    path: '/verein/mitglieder/',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinPraemienIndexRoute = AppVereinPraemienIndexRouteImport.update({
  id: '/verein/praemien/',
  path: '/verein/praemien/',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinPraemienAbschlussRoute =
  AppVereinPraemienAbschlussRouteImport.update({
    id: '/verein/praemien/abschluss',
    path: '/verein/praemien/abschluss',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinPraemienArtenRoute = AppVereinPraemienArtenRouteImport.update({
  id: '/verein/praemien/arten',
  path: '/verein/praemien/arten',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinSponsorenIndexRoute = AppVereinSponsorenIndexRouteImport.update({
  id: '/verein/sponsoren/',
  path: '/verein/sponsoren/',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinVorstandIndexRoute = AppVereinVorstandIndexRouteImport.update({
  id: '/verein/vorstand/',
  path: '/verein/vorstand/',
  getParentRoute: () => AppRoute,
} as any)
const AppVereinPraemienVertraegeIndexRoute =
  AppVereinPraemienVertraegeIndexRouteImport.update({
    id: '/verein/praemien/vertraege/',
    path: '/verein/praemien/vertraege/',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinPraemienVertraegeContractIdRoute =
  AppVereinPraemienVertraegeContractIdRouteImport.update({
    id: '/verein/praemien/vertraege/$contractId',
    path: '/verein/praemien/vertraege/$contractId',
    getParentRoute: () => AppRoute,
  } as any)
const AppVereinPraemienVertraegeNeuRoute =
  AppVereinPraemienVertraegeNeuRouteImport.update({
    id: '/verein/praemien/vertraege/neu',
    path: '/verein/praemien/vertraege/neu',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/datenschutz': typeof DatenschutzRoute
  '/email-bestaetigen': typeof EmailBestaetigenRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/passwort-neu': typeof PasswortNeuRoute
  '/passwort-vergessen': typeof PasswortVergessenRoute
  '/registrieren': typeof RegistrierenRoute
  '/setup': typeof SetupRoute
  '/start': typeof StartRoute
  '/ui': typeof UiRoute
  '/konto': typeof AppKontoRoute
  '/einladung/$token': typeof EinladungTokenRoute
  '/profil/$token': typeof ProfilTokenRoute
  '/ich/abrechnungen': typeof AppIchAbrechnungenRoute
  '/ich/termine': typeof AppIchTermineRoute
  '/kader/$personId': typeof AppKaderPersonIdRoute
  '/kader/medizin': typeof AppKaderMedizinRoute
  '/kader/statistik': typeof AppKaderStatistikRoute
  '/kader/vergleich': typeof AppKaderVergleichRoute
  '/spiele/$matchId': typeof AppSpieleMatchIdRoute
  '/spiele/video': typeof AppSpieleVideoRoute
  '/taktik/$boardId': typeof AppTaktikBoardIdRoute
  '/training/$sessionId': typeof AppTrainingSessionIdRoute
  '/training/anwesenheit': typeof AppTrainingAnwesenheitRoute
  '/training/kalender': typeof AppTrainingKalenderRoute
  '/ich/': typeof AppIchIndexRoute
  '/kader/': typeof AppKaderIndexRoute
  '/liga/': typeof AppLigaIndexRoute
  '/spiele/': typeof AppSpieleIndexRoute
  '/taktik/': typeof AppTaktikIndexRoute
  '/training/': typeof AppTrainingIndexRoute
  '/verein/': typeof AppVereinIndexRoute
  '/kader/talente/$prospectId': typeof AppKaderTalenteProspectIdRoute
  '/liga/vereine/$clubId': typeof AppLigaVereineClubIdRoute
  '/verein/betrieb/belegung': typeof AppVereinBetriebBelegungRoute
  '/verein/betrieb/dienste': typeof AppVereinBetriebDiensteRoute
  '/verein/betrieb/inventar': typeof AppVereinBetriebInventarRoute
  '/verein/datenquellen/zuordnungen': typeof AppVereinDatenquellenZuordnungenRoute
  '/verein/finanzen/kassenbuch': typeof AppVereinFinanzenKassenbuchRoute
  '/verein/finanzen/konten': typeof AppVereinFinanzenKontenRoute
  '/verein/praemien/abschluss': typeof AppVereinPraemienAbschlussRoute
  '/verein/praemien/arten': typeof AppVereinPraemienArtenRoute
  '/kader/talente/': typeof AppKaderTalenteIndexRoute
  '/liga/vereine/': typeof AppLigaVereineIndexRoute
  '/verein/betrieb/': typeof AppVereinBetriebIndexRoute
  '/verein/budgets/': typeof AppVereinBudgetsIndexRoute
  '/verein/datenquellen/': typeof AppVereinDatenquellenIndexRoute
  '/verein/datenschutz/': typeof AppVereinDatenschutzIndexRoute
  '/verein/einstellungen/': typeof AppVereinEinstellungenIndexRoute
  '/verein/fahrtkosten/': typeof AppVereinFahrtkostenIndexRoute
  '/verein/finanzen/': typeof AppVereinFinanzenIndexRoute
  '/verein/mitglieder/': typeof AppVereinMitgliederIndexRoute
  '/verein/praemien/': typeof AppVereinPraemienIndexRoute
  '/verein/sponsoren/': typeof AppVereinSponsorenIndexRoute
  '/verein/vorstand/': typeof AppVereinVorstandIndexRoute
  '/verein/praemien/vertraege/$contractId': typeof AppVereinPraemienVertraegeContractIdRoute
  '/verein/praemien/vertraege/neu': typeof AppVereinPraemienVertraegeNeuRoute
  '/verein/praemien/vertraege/': typeof AppVereinPraemienVertraegeIndexRoute
}
export interface FileRoutesByTo {
  '/datenschutz': typeof DatenschutzRoute
  '/email-bestaetigen': typeof EmailBestaetigenRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/passwort-neu': typeof PasswortNeuRoute
  '/passwort-vergessen': typeof PasswortVergessenRoute
  '/registrieren': typeof RegistrierenRoute
  '/setup': typeof SetupRoute
  '/start': typeof StartRoute
  '/ui': typeof UiRoute
  '/konto': typeof AppKontoRoute
  '/einladung/$token': typeof EinladungTokenRoute
  '/profil/$token': typeof ProfilTokenRoute
  '/': typeof AppIndexRoute
  '/ich/abrechnungen': typeof AppIchAbrechnungenRoute
  '/ich/termine': typeof AppIchTermineRoute
  '/kader/$personId': typeof AppKaderPersonIdRoute
  '/kader/medizin': typeof AppKaderMedizinRoute
  '/kader/statistik': typeof AppKaderStatistikRoute
  '/kader/vergleich': typeof AppKaderVergleichRoute
  '/spiele/$matchId': typeof AppSpieleMatchIdRoute
  '/spiele/video': typeof AppSpieleVideoRoute
  '/taktik/$boardId': typeof AppTaktikBoardIdRoute
  '/training/$sessionId': typeof AppTrainingSessionIdRoute
  '/training/anwesenheit': typeof AppTrainingAnwesenheitRoute
  '/training/kalender': typeof AppTrainingKalenderRoute
  '/ich': typeof AppIchIndexRoute
  '/kader': typeof AppKaderIndexRoute
  '/liga': typeof AppLigaIndexRoute
  '/spiele': typeof AppSpieleIndexRoute
  '/taktik': typeof AppTaktikIndexRoute
  '/training': typeof AppTrainingIndexRoute
  '/verein': typeof AppVereinIndexRoute
  '/kader/talente/$prospectId': typeof AppKaderTalenteProspectIdRoute
  '/liga/vereine/$clubId': typeof AppLigaVereineClubIdRoute
  '/verein/betrieb/belegung': typeof AppVereinBetriebBelegungRoute
  '/verein/betrieb/dienste': typeof AppVereinBetriebDiensteRoute
  '/verein/betrieb/inventar': typeof AppVereinBetriebInventarRoute
  '/verein/datenquellen/zuordnungen': typeof AppVereinDatenquellenZuordnungenRoute
  '/verein/finanzen/kassenbuch': typeof AppVereinFinanzenKassenbuchRoute
  '/verein/finanzen/konten': typeof AppVereinFinanzenKontenRoute
  '/verein/praemien/abschluss': typeof AppVereinPraemienAbschlussRoute
  '/verein/praemien/arten': typeof AppVereinPraemienArtenRoute
  '/kader/talente': typeof AppKaderTalenteIndexRoute
  '/liga/vereine': typeof AppLigaVereineIndexRoute
  '/verein/betrieb': typeof AppVereinBetriebIndexRoute
  '/verein/budgets': typeof AppVereinBudgetsIndexRoute
  '/verein/datenquellen': typeof AppVereinDatenquellenIndexRoute
  '/verein/datenschutz': typeof AppVereinDatenschutzIndexRoute
  '/verein/einstellungen': typeof AppVereinEinstellungenIndexRoute
  '/verein/fahrtkosten': typeof AppVereinFahrtkostenIndexRoute
  '/verein/finanzen': typeof AppVereinFinanzenIndexRoute
  '/verein/mitglieder': typeof AppVereinMitgliederIndexRoute
  '/verein/praemien': typeof AppVereinPraemienIndexRoute
  '/verein/sponsoren': typeof AppVereinSponsorenIndexRoute
  '/verein/vorstand': typeof AppVereinVorstandIndexRoute
  '/verein/praemien/vertraege/$contractId': typeof AppVereinPraemienVertraegeContractIdRoute
  '/verein/praemien/vertraege/neu': typeof AppVereinPraemienVertraegeNeuRoute
  '/verein/praemien/vertraege': typeof AppVereinPraemienVertraegeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/datenschutz': typeof DatenschutzRoute
  '/email-bestaetigen': typeof EmailBestaetigenRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/passwort-neu': typeof PasswortNeuRoute
  '/passwort-vergessen': typeof PasswortVergessenRoute
  '/registrieren': typeof RegistrierenRoute
  '/setup': typeof SetupRoute
  '/start': typeof StartRoute
  '/ui': typeof UiRoute
  '/_app/konto': typeof AppKontoRoute
  '/einladung/$token': typeof EinladungTokenRoute
  '/profil/$token': typeof ProfilTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/ich/abrechnungen': typeof AppIchAbrechnungenRoute
  '/_app/ich/termine': typeof AppIchTermineRoute
  '/_app/kader/$personId': typeof AppKaderPersonIdRoute
  '/_app/kader/medizin': typeof AppKaderMedizinRoute
  '/_app/kader/statistik': typeof AppKaderStatistikRoute
  '/_app/kader/vergleich': typeof AppKaderVergleichRoute
  '/_app/spiele/$matchId': typeof AppSpieleMatchIdRoute
  '/_app/spiele/video': typeof AppSpieleVideoRoute
  '/_app/taktik/$boardId': typeof AppTaktikBoardIdRoute
  '/_app/training/$sessionId': typeof AppTrainingSessionIdRoute
  '/_app/training/anwesenheit': typeof AppTrainingAnwesenheitRoute
  '/_app/training/kalender': typeof AppTrainingKalenderRoute
  '/_app/ich/': typeof AppIchIndexRoute
  '/_app/kader/': typeof AppKaderIndexRoute
  '/_app/liga/': typeof AppLigaIndexRoute
  '/_app/spiele/': typeof AppSpieleIndexRoute
  '/_app/taktik/': typeof AppTaktikIndexRoute
  '/_app/training/': typeof AppTrainingIndexRoute
  '/_app/verein/': typeof AppVereinIndexRoute
  '/_app/kader/talente/$prospectId': typeof AppKaderTalenteProspectIdRoute
  '/_app/liga/vereine/$clubId': typeof AppLigaVereineClubIdRoute
  '/_app/verein/betrieb/belegung': typeof AppVereinBetriebBelegungRoute
  '/_app/verein/betrieb/dienste': typeof AppVereinBetriebDiensteRoute
  '/_app/verein/betrieb/inventar': typeof AppVereinBetriebInventarRoute
  '/_app/verein/datenquellen/zuordnungen': typeof AppVereinDatenquellenZuordnungenRoute
  '/_app/verein/finanzen/kassenbuch': typeof AppVereinFinanzenKassenbuchRoute
  '/_app/verein/finanzen/konten': typeof AppVereinFinanzenKontenRoute
  '/_app/verein/praemien/abschluss': typeof AppVereinPraemienAbschlussRoute
  '/_app/verein/praemien/arten': typeof AppVereinPraemienArtenRoute
  '/_app/kader/talente/': typeof AppKaderTalenteIndexRoute
  '/_app/liga/vereine/': typeof AppLigaVereineIndexRoute
  '/_app/verein/betrieb/': typeof AppVereinBetriebIndexRoute
  '/_app/verein/budgets/': typeof AppVereinBudgetsIndexRoute
  '/_app/verein/datenquellen/': typeof AppVereinDatenquellenIndexRoute
  '/_app/verein/datenschutz/': typeof AppVereinDatenschutzIndexRoute
  '/_app/verein/einstellungen/': typeof AppVereinEinstellungenIndexRoute
  '/_app/verein/fahrtkosten/': typeof AppVereinFahrtkostenIndexRoute
  '/_app/verein/finanzen/': typeof AppVereinFinanzenIndexRoute
  '/_app/verein/mitglieder/': typeof AppVereinMitgliederIndexRoute
  '/_app/verein/praemien/': typeof AppVereinPraemienIndexRoute
  '/_app/verein/sponsoren/': typeof AppVereinSponsorenIndexRoute
  '/_app/verein/vorstand/': typeof AppVereinVorstandIndexRoute
  '/_app/verein/praemien/vertraege/$contractId': typeof AppVereinPraemienVertraegeContractIdRoute
  '/_app/verein/praemien/vertraege/neu': typeof AppVereinPraemienVertraegeNeuRoute
  '/_app/verein/praemien/vertraege/': typeof AppVereinPraemienVertraegeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/datenschutz'
    | '/email-bestaetigen'
    | '/impressum'
    | '/login'
    | '/passwort-neu'
    | '/passwort-vergessen'
    | '/registrieren'
    | '/setup'
    | '/start'
    | '/ui'
    | '/konto'
    | '/einladung/$token'
    | '/profil/$token'
    | '/ich/abrechnungen'
    | '/ich/termine'
    | '/kader/$personId'
    | '/kader/medizin'
    | '/kader/statistik'
    | '/kader/vergleich'
    | '/spiele/$matchId'
    | '/spiele/video'
    | '/taktik/$boardId'
    | '/training/$sessionId'
    | '/training/anwesenheit'
    | '/training/kalender'
    | '/ich/'
    | '/kader/'
    | '/liga/'
    | '/spiele/'
    | '/taktik/'
    | '/training/'
    | '/verein/'
    | '/kader/talente/$prospectId'
    | '/liga/vereine/$clubId'
    | '/verein/betrieb/belegung'
    | '/verein/betrieb/dienste'
    | '/verein/betrieb/inventar'
    | '/verein/datenquellen/zuordnungen'
    | '/verein/finanzen/kassenbuch'
    | '/verein/finanzen/konten'
    | '/verein/praemien/abschluss'
    | '/verein/praemien/arten'
    | '/kader/talente/'
    | '/liga/vereine/'
    | '/verein/betrieb/'
    | '/verein/budgets/'
    | '/verein/datenquellen/'
    | '/verein/datenschutz/'
    | '/verein/einstellungen/'
    | '/verein/fahrtkosten/'
    | '/verein/finanzen/'
    | '/verein/mitglieder/'
    | '/verein/praemien/'
    | '/verein/sponsoren/'
    | '/verein/vorstand/'
    | '/verein/praemien/vertraege/$contractId'
    | '/verein/praemien/vertraege/neu'
    | '/verein/praemien/vertraege/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/datenschutz'
    | '/email-bestaetigen'
    | '/impressum'
    | '/login'
    | '/passwort-neu'
    | '/passwort-vergessen'
    | '/registrieren'
    | '/setup'
    | '/start'
    | '/ui'
    | '/konto'
    | '/einladung/$token'
    | '/profil/$token'
    | '/'
    | '/ich/abrechnungen'
    | '/ich/termine'
    | '/kader/$personId'
    | '/kader/medizin'
    | '/kader/statistik'
    | '/kader/vergleich'
    | '/spiele/$matchId'
    | '/spiele/video'
    | '/taktik/$boardId'
    | '/training/$sessionId'
    | '/training/anwesenheit'
    | '/training/kalender'
    | '/ich'
    | '/kader'
    | '/liga'
    | '/spiele'
    | '/taktik'
    | '/training'
    | '/verein'
    | '/kader/talente/$prospectId'
    | '/liga/vereine/$clubId'
    | '/verein/betrieb/belegung'
    | '/verein/betrieb/dienste'
    | '/verein/betrieb/inventar'
    | '/verein/datenquellen/zuordnungen'
    | '/verein/finanzen/kassenbuch'
    | '/verein/finanzen/konten'
    | '/verein/praemien/abschluss'
    | '/verein/praemien/arten'
    | '/kader/talente'
    | '/liga/vereine'
    | '/verein/betrieb'
    | '/verein/budgets'
    | '/verein/datenquellen'
    | '/verein/datenschutz'
    | '/verein/einstellungen'
    | '/verein/fahrtkosten'
    | '/verein/finanzen'
    | '/verein/mitglieder'
    | '/verein/praemien'
    | '/verein/sponsoren'
    | '/verein/vorstand'
    | '/verein/praemien/vertraege/$contractId'
    | '/verein/praemien/vertraege/neu'
    | '/verein/praemien/vertraege'
  id:
    | '__root__'
    | '/_app'
    | '/datenschutz'
    | '/email-bestaetigen'
    | '/impressum'
    | '/login'
    | '/passwort-neu'
    | '/passwort-vergessen'
    | '/registrieren'
    | '/setup'
    | '/start'
    | '/ui'
    | '/_app/konto'
    | '/einladung/$token'
    | '/profil/$token'
    | '/_app/'
    | '/_app/ich/abrechnungen'
    | '/_app/ich/termine'
    | '/_app/kader/$personId'
    | '/_app/kader/medizin'
    | '/_app/kader/statistik'
    | '/_app/kader/vergleich'
    | '/_app/spiele/$matchId'
    | '/_app/spiele/video'
    | '/_app/taktik/$boardId'
    | '/_app/training/$sessionId'
    | '/_app/training/anwesenheit'
    | '/_app/training/kalender'
    | '/_app/ich/'
    | '/_app/kader/'
    | '/_app/liga/'
    | '/_app/spiele/'
    | '/_app/taktik/'
    | '/_app/training/'
    | '/_app/verein/'
    | '/_app/kader/talente/$prospectId'
    | '/_app/liga/vereine/$clubId'
    | '/_app/verein/betrieb/belegung'
    | '/_app/verein/betrieb/dienste'
    | '/_app/verein/betrieb/inventar'
    | '/_app/verein/datenquellen/zuordnungen'
    | '/_app/verein/finanzen/kassenbuch'
    | '/_app/verein/finanzen/konten'
    | '/_app/verein/praemien/abschluss'
    | '/_app/verein/praemien/arten'
    | '/_app/kader/talente/'
    | '/_app/liga/vereine/'
    | '/_app/verein/betrieb/'
    | '/_app/verein/budgets/'
    | '/_app/verein/datenquellen/'
    | '/_app/verein/datenschutz/'
    | '/_app/verein/einstellungen/'
    | '/_app/verein/fahrtkosten/'
    | '/_app/verein/finanzen/'
    | '/_app/verein/mitglieder/'
    | '/_app/verein/praemien/'
    | '/_app/verein/sponsoren/'
    | '/_app/verein/vorstand/'
    | '/_app/verein/praemien/vertraege/$contractId'
    | '/_app/verein/praemien/vertraege/neu'
    | '/_app/verein/praemien/vertraege/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  DatenschutzRoute: typeof DatenschutzRoute
  EmailBestaetigenRoute: typeof EmailBestaetigenRoute
  ImpressumRoute: typeof ImpressumRoute
  LoginRoute: typeof LoginRoute
  PasswortNeuRoute: typeof PasswortNeuRoute
  PasswortVergessenRoute: typeof PasswortVergessenRoute
  RegistrierenRoute: typeof RegistrierenRoute
  SetupRoute: typeof SetupRoute
  StartRoute: typeof StartRoute
  UiRoute: typeof UiRoute
  EinladungTokenRoute: typeof EinladungTokenRoute
  ProfilTokenRoute: typeof ProfilTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datenschutz': {
      id: '/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof DatenschutzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-bestaetigen': {
      id: '/email-bestaetigen'
      path: '/email-bestaetigen'
      fullPath: '/email-bestaetigen'
      preLoaderRoute: typeof EmailBestaetigenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passwort-neu': {
      id: '/passwort-neu'
      path: '/passwort-neu'
      fullPath: '/passwort-neu'
      preLoaderRoute: typeof PasswortNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passwort-vergessen': {
      id: '/passwort-vergessen'
      path: '/passwort-vergessen'
      fullPath: '/passwort-vergessen'
      preLoaderRoute: typeof PasswortVergessenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registrieren': {
      id: '/registrieren'
      path: '/registrieren'
      fullPath: '/registrieren'
      preLoaderRoute: typeof RegistrierenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui': {
      id: '/ui'
      path: '/ui'
      fullPath: '/ui'
      preLoaderRoute: typeof UiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/konto': {
      id: '/_app/konto'
      path: '/konto'
      fullPath: '/konto'
      preLoaderRoute: typeof AppKontoRouteImport
      parentRoute: typeof AppRoute
    }
    '/einladung/$token': {
      id: '/einladung/$token'
      path: '/einladung/$token'
      fullPath: '/einladung/$token'
      preLoaderRoute: typeof EinladungTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profil/$token': {
      id: '/profil/$token'
      path: '/profil/$token'
      fullPath: '/profil/$token'
      preLoaderRoute: typeof ProfilTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/ich/': {
      id: '/_app/ich/'
      path: '/ich'
      fullPath: '/ich/'
      preLoaderRoute: typeof AppIchIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ich/abrechnungen': {
      id: '/_app/ich/abrechnungen'
      path: '/ich/abrechnungen'
      fullPath: '/ich/abrechnungen'
      preLoaderRoute: typeof AppIchAbrechnungenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ich/termine': {
      id: '/_app/ich/termine'
      path: '/ich/termine'
      fullPath: '/ich/termine'
      preLoaderRoute: typeof AppIchTermineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kader/': {
      id: '/_app/kader/'
      path: '/kader'
      fullPath: '/kader/'
      preLoaderRoute: typeof AppKaderIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kader/$personId': {
      id: '/_app/kader/$personId'
      path: '/kader/$personId'
      fullPath: '/kader/$personId'
      preLoaderRoute: typeof AppKaderPersonIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kader/medizin': {
      id: '/_app/kader/medizin'
      path: '/kader/medizin'
      fullPath: '/kader/medizin'
      preLoaderRoute: typeof AppKaderMedizinRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kader/statistik': {
      id: '/_app/kader/statistik'
      path: '/kader/statistik'
      fullPath: '/kader/statistik'
      preLoaderRoute: typeof AppKaderStatistikRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kader/vergleich': {
      id: '/_app/kader/vergleich'
      path: '/kader/vergleich'
      fullPath: '/kader/vergleich'
      preLoaderRoute: typeof AppKaderVergleichRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/liga/': {
      id: '/_app/liga/'
      path: '/liga'
      fullPath: '/liga/'
      preLoaderRoute: typeof AppLigaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spiele/': {
      id: '/_app/spiele/'
      path: '/spiele'
      fullPath: '/spiele/'
      preLoaderRoute: typeof AppSpieleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spiele/$matchId': {
      id: '/_app/spiele/$matchId'
      path: '/spiele/$matchId'
      fullPath: '/spiele/$matchId'
      preLoaderRoute: typeof AppSpieleMatchIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spiele/video': {
      id: '/_app/spiele/video'
      path: '/spiele/video'
      fullPath: '/spiele/video'
      preLoaderRoute: typeof AppSpieleVideoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/taktik/': {
      id: '/_app/taktik/'
      path: '/taktik'
      fullPath: '/taktik/'
      preLoaderRoute: typeof AppTaktikIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/taktik/$boardId': {
      id: '/_app/taktik/$boardId'
      path: '/taktik/$boardId'
      fullPath: '/taktik/$boardId'
      preLoaderRoute: typeof AppTaktikBoardIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/training/': {
      id: '/_app/training/'
      path: '/training'
      fullPath: '/training/'
      preLoaderRoute: typeof AppTrainingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/training/$sessionId': {
      id: '/_app/training/$sessionId'
      path: '/training/$sessionId'
      fullPath: '/training/$sessionId'
      preLoaderRoute: typeof AppTrainingSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/training/anwesenheit': {
      id: '/_app/training/anwesenheit'
      path: '/training/anwesenheit'
      fullPath: '/training/anwesenheit'
      preLoaderRoute: typeof AppTrainingAnwesenheitRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/training/kalender': {
      id: '/_app/training/kalender'
      path: '/training/kalender'
      fullPath: '/training/kalender'
      preLoaderRoute: typeof AppTrainingKalenderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/': {
      id: '/_app/verein/'
      path: '/verein'
      fullPath: '/verein/'
      preLoaderRoute: typeof AppVereinIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kader/talente/': {
      id: '/_app/kader/talente/'
      path: '/kader/talente'
      fullPath: '/kader/talente/'
      preLoaderRoute: typeof AppKaderTalenteIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kader/talente/$prospectId': {
      id: '/_app/kader/talente/$prospectId'
      path: '/kader/talente/$prospectId'
      fullPath: '/kader/talente/$prospectId'
      preLoaderRoute: typeof AppKaderTalenteProspectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/liga/vereine/': {
      id: '/_app/liga/vereine/'
      path: '/liga/vereine'
      fullPath: '/liga/vereine/'
      preLoaderRoute: typeof AppLigaVereineIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/liga/vereine/$clubId': {
      id: '/_app/liga/vereine/$clubId'
      path: '/liga/vereine/$clubId'
      fullPath: '/liga/vereine/$clubId'
      preLoaderRoute: typeof AppLigaVereineClubIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/betrieb/': {
      id: '/_app/verein/betrieb/'
      path: '/verein/betrieb'
      fullPath: '/verein/betrieb/'
      preLoaderRoute: typeof AppVereinBetriebIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/betrieb/belegung': {
      id: '/_app/verein/betrieb/belegung'
      path: '/verein/betrieb/belegung'
      fullPath: '/verein/betrieb/belegung'
      preLoaderRoute: typeof AppVereinBetriebBelegungRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/betrieb/dienste': {
      id: '/_app/verein/betrieb/dienste'
      path: '/verein/betrieb/dienste'
      fullPath: '/verein/betrieb/dienste'
      preLoaderRoute: typeof AppVereinBetriebDiensteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/betrieb/inventar': {
      id: '/_app/verein/betrieb/inventar'
      path: '/verein/betrieb/inventar'
      fullPath: '/verein/betrieb/inventar'
      preLoaderRoute: typeof AppVereinBetriebInventarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/budgets/': {
      id: '/_app/verein/budgets/'
      path: '/verein/budgets'
      fullPath: '/verein/budgets/'
      preLoaderRoute: typeof AppVereinBudgetsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/datenquellen/': {
      id: '/_app/verein/datenquellen/'
      path: '/verein/datenquellen'
      fullPath: '/verein/datenquellen/'
      preLoaderRoute: typeof AppVereinDatenquellenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/datenquellen/zuordnungen': {
      id: '/_app/verein/datenquellen/zuordnungen'
      path: '/verein/datenquellen/zuordnungen'
      fullPath: '/verein/datenquellen/zuordnungen'
      preLoaderRoute: typeof AppVereinDatenquellenZuordnungenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/datenschutz/': {
      id: '/_app/verein/datenschutz/'
      path: '/verein/datenschutz'
      fullPath: '/verein/datenschutz/'
      preLoaderRoute: typeof AppVereinDatenschutzIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/einstellungen/': {
      id: '/_app/verein/einstellungen/'
      path: '/verein/einstellungen'
      fullPath: '/verein/einstellungen/'
      preLoaderRoute: typeof AppVereinEinstellungenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/fahrtkosten/': {
      id: '/_app/verein/fahrtkosten/'
      path: '/verein/fahrtkosten'
      fullPath: '/verein/fahrtkosten/'
      preLoaderRoute: typeof AppVereinFahrtkostenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/finanzen/': {
      id: '/_app/verein/finanzen/'
      path: '/verein/finanzen'
      fullPath: '/verein/finanzen/'
      preLoaderRoute: typeof AppVereinFinanzenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/finanzen/kassenbuch': {
      id: '/_app/verein/finanzen/kassenbuch'
      path: '/verein/finanzen/kassenbuch'
      fullPath: '/verein/finanzen/kassenbuch'
      preLoaderRoute: typeof AppVereinFinanzenKassenbuchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/finanzen/konten': {
      id: '/_app/verein/finanzen/konten'
      path: '/verein/finanzen/konten'
      fullPath: '/verein/finanzen/konten'
      preLoaderRoute: typeof AppVereinFinanzenKontenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/mitglieder/': {
      id: '/_app/verein/mitglieder/'
      path: '/verein/mitglieder'
      fullPath: '/verein/mitglieder/'
      preLoaderRoute: typeof AppVereinMitgliederIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/praemien/': {
      id: '/_app/verein/praemien/'
      path: '/verein/praemien'
      fullPath: '/verein/praemien/'
      preLoaderRoute: typeof AppVereinPraemienIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/praemien/abschluss': {
      id: '/_app/verein/praemien/abschluss'
      path: '/verein/praemien/abschluss'
      fullPath: '/verein/praemien/abschluss'
      preLoaderRoute: typeof AppVereinPraemienAbschlussRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/praemien/arten': {
      id: '/_app/verein/praemien/arten'
      path: '/verein/praemien/arten'
      fullPath: '/verein/praemien/arten'
      preLoaderRoute: typeof AppVereinPraemienArtenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/sponsoren/': {
      id: '/_app/verein/sponsoren/'
      path: '/verein/sponsoren'
      fullPath: '/verein/sponsoren/'
      preLoaderRoute: typeof AppVereinSponsorenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/vorstand/': {
      id: '/_app/verein/vorstand/'
      path: '/verein/vorstand'
      fullPath: '/verein/vorstand/'
      preLoaderRoute: typeof AppVereinVorstandIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/praemien/vertraege/': {
      id: '/_app/verein/praemien/vertraege/'
      path: '/verein/praemien/vertraege'
      fullPath: '/verein/praemien/vertraege/'
      preLoaderRoute: typeof AppVereinPraemienVertraegeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/praemien/vertraege/$contractId': {
      id: '/_app/verein/praemien/vertraege/$contractId'
      path: '/verein/praemien/vertraege/$contractId'
      fullPath: '/verein/praemien/vertraege/$contractId'
      preLoaderRoute: typeof AppVereinPraemienVertraegeContractIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verein/praemien/vertraege/neu': {
      id: '/_app/verein/praemien/vertraege/neu'
      path: '/verein/praemien/vertraege/neu'
      fullPath: '/verein/praemien/vertraege/neu'
      preLoaderRoute: typeof AppVereinPraemienVertraegeNeuRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppKontoRoute: typeof AppKontoRoute
  AppIndexRoute: typeof AppIndexRoute
  AppIchAbrechnungenRoute: typeof AppIchAbrechnungenRoute
  AppIchTermineRoute: typeof AppIchTermineRoute
  AppKaderPersonIdRoute: typeof AppKaderPersonIdRoute
  AppKaderMedizinRoute: typeof AppKaderMedizinRoute
  AppKaderStatistikRoute: typeof AppKaderStatistikRoute
  AppKaderVergleichRoute: typeof AppKaderVergleichRoute
  AppSpieleMatchIdRoute: typeof AppSpieleMatchIdRoute
  AppSpieleVideoRoute: typeof AppSpieleVideoRoute
  AppTaktikBoardIdRoute: typeof AppTaktikBoardIdRoute
  AppTrainingSessionIdRoute: typeof AppTrainingSessionIdRoute
  AppTrainingAnwesenheitRoute: typeof AppTrainingAnwesenheitRoute
  AppTrainingKalenderRoute: typeof AppTrainingKalenderRoute
  AppIchIndexRoute: typeof AppIchIndexRoute
  AppKaderIndexRoute: typeof AppKaderIndexRoute
  AppLigaIndexRoute: typeof AppLigaIndexRoute
  AppSpieleIndexRoute: typeof AppSpieleIndexRoute
  AppTaktikIndexRoute: typeof AppTaktikIndexRoute
  AppTrainingIndexRoute: typeof AppTrainingIndexRoute
  AppVereinIndexRoute: typeof AppVereinIndexRoute
  AppKaderTalenteProspectIdRoute: typeof AppKaderTalenteProspectIdRoute
  AppLigaVereineClubIdRoute: typeof AppLigaVereineClubIdRoute
  AppVereinBetriebBelegungRoute: typeof AppVereinBetriebBelegungRoute
  AppVereinBetriebDiensteRoute: typeof AppVereinBetriebDiensteRoute
  AppVereinBetriebInventarRoute: typeof AppVereinBetriebInventarRoute
  AppVereinDatenquellenZuordnungenRoute: typeof AppVereinDatenquellenZuordnungenRoute
  AppVereinFinanzenKassenbuchRoute: typeof AppVereinFinanzenKassenbuchRoute
  AppVereinFinanzenKontenRoute: typeof AppVereinFinanzenKontenRoute
  AppVereinPraemienAbschlussRoute: typeof AppVereinPraemienAbschlussRoute
  AppVereinPraemienArtenRoute: typeof AppVereinPraemienArtenRoute
  AppKaderTalenteIndexRoute: typeof AppKaderTalenteIndexRoute
  AppLigaVereineIndexRoute: typeof AppLigaVereineIndexRoute
  AppVereinBetriebIndexRoute: typeof AppVereinBetriebIndexRoute
  AppVereinBudgetsIndexRoute: typeof AppVereinBudgetsIndexRoute
  AppVereinDatenquellenIndexRoute: typeof AppVereinDatenquellenIndexRoute
  AppVereinDatenschutzIndexRoute: typeof AppVereinDatenschutzIndexRoute
  AppVereinEinstellungenIndexRoute: typeof AppVereinEinstellungenIndexRoute
  AppVereinFahrtkostenIndexRoute: typeof AppVereinFahrtkostenIndexRoute
  AppVereinFinanzenIndexRoute: typeof AppVereinFinanzenIndexRoute
  AppVereinMitgliederIndexRoute: typeof AppVereinMitgliederIndexRoute
  AppVereinPraemienIndexRoute: typeof AppVereinPraemienIndexRoute
  AppVereinSponsorenIndexRoute: typeof AppVereinSponsorenIndexRoute
  AppVereinVorstandIndexRoute: typeof AppVereinVorstandIndexRoute
  AppVereinPraemienVertraegeContractIdRoute: typeof AppVereinPraemienVertraegeContractIdRoute
  AppVereinPraemienVertraegeNeuRoute: typeof AppVereinPraemienVertraegeNeuRoute
  AppVereinPraemienVertraegeIndexRoute: typeof AppVereinPraemienVertraegeIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppKontoRoute: AppKontoRoute,
  AppIndexRoute: AppIndexRoute,
  AppIchAbrechnungenRoute: AppIchAbrechnungenRoute,
  AppIchTermineRoute: AppIchTermineRoute,
  AppKaderPersonIdRoute: AppKaderPersonIdRoute,
  AppKaderMedizinRoute: AppKaderMedizinRoute,
  AppKaderStatistikRoute: AppKaderStatistikRoute,
  AppKaderVergleichRoute: AppKaderVergleichRoute,
  AppSpieleMatchIdRoute: AppSpieleMatchIdRoute,
  AppSpieleVideoRoute: AppSpieleVideoRoute,
  AppTaktikBoardIdRoute: AppTaktikBoardIdRoute,
  AppTrainingSessionIdRoute: AppTrainingSessionIdRoute,
  AppTrainingAnwesenheitRoute: AppTrainingAnwesenheitRoute,
  AppTrainingKalenderRoute: AppTrainingKalenderRoute,
  AppIchIndexRoute: AppIchIndexRoute,
  AppKaderIndexRoute: AppKaderIndexRoute,
  AppLigaIndexRoute: AppLigaIndexRoute,
  AppSpieleIndexRoute: AppSpieleIndexRoute,
  AppTaktikIndexRoute: AppTaktikIndexRoute,
  AppTrainingIndexRoute: AppTrainingIndexRoute,
  AppVereinIndexRoute: AppVereinIndexRoute,
  AppKaderTalenteProspectIdRoute: AppKaderTalenteProspectIdRoute,
  AppLigaVereineClubIdRoute: AppLigaVereineClubIdRoute,
  AppVereinBetriebBelegungRoute: AppVereinBetriebBelegungRoute,
  AppVereinBetriebDiensteRoute: AppVereinBetriebDiensteRoute,
  AppVereinBetriebInventarRoute: AppVereinBetriebInventarRoute,
  AppVereinDatenquellenZuordnungenRoute: AppVereinDatenquellenZuordnungenRoute,
  AppVereinFinanzenKassenbuchRoute: AppVereinFinanzenKassenbuchRoute,
  AppVereinFinanzenKontenRoute: AppVereinFinanzenKontenRoute,
  AppVereinPraemienAbschlussRoute: AppVereinPraemienAbschlussRoute,
  AppVereinPraemienArtenRoute: AppVereinPraemienArtenRoute,
  AppKaderTalenteIndexRoute: AppKaderTalenteIndexRoute,
  AppLigaVereineIndexRoute: AppLigaVereineIndexRoute,
  AppVereinBetriebIndexRoute: AppVereinBetriebIndexRoute,
  AppVereinBudgetsIndexRoute: AppVereinBudgetsIndexRoute,
  AppVereinDatenquellenIndexRoute: AppVereinDatenquellenIndexRoute,
  AppVereinDatenschutzIndexRoute: AppVereinDatenschutzIndexRoute,
  AppVereinEinstellungenIndexRoute: AppVereinEinstellungenIndexRoute,
  AppVereinFahrtkostenIndexRoute: AppVereinFahrtkostenIndexRoute,
  AppVereinFinanzenIndexRoute: AppVereinFinanzenIndexRoute,
  AppVereinMitgliederIndexRoute: AppVereinMitgliederIndexRoute,
  AppVereinPraemienIndexRoute: AppVereinPraemienIndexRoute,
  AppVereinSponsorenIndexRoute: AppVereinSponsorenIndexRoute,
  AppVereinVorstandIndexRoute: AppVereinVorstandIndexRoute,
  AppVereinPraemienVertraegeContractIdRoute:
    AppVereinPraemienVertraegeContractIdRoute,
  AppVereinPraemienVertraegeNeuRoute: AppVereinPraemienVertraegeNeuRoute,
  AppVereinPraemienVertraegeIndexRoute: AppVereinPraemienVertraegeIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DatenschutzRoute: DatenschutzRoute,
  EmailBestaetigenRoute: EmailBestaetigenRoute,
  ImpressumRoute: ImpressumRoute,
  LoginRoute: LoginRoute,
  PasswortNeuRoute: PasswortNeuRoute,
  PasswortVergessenRoute: PasswortVergessenRoute,
  RegistrierenRoute: RegistrierenRoute,
  SetupRoute: SetupRoute,
  StartRoute: StartRoute,
  UiRoute: UiRoute,
  EinladungTokenRoute: EinladungTokenRoute,
  ProfilTokenRoute: ProfilTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
